// extracted by mini-css-extract-plugin
export default {"activitiesPopupBody":"activitiesPopup_activitiesPopupBody__AMReJ","latestActionsContainer":"activitiesPopup_latestActionsContainer__zfr8a"};